import { render, staticRenderFns } from "./Favicon.vue?vue&type=template&id=bcfadf10&scoped=true&"
import script from "./Favicon.vue?vue&type=script&lang=js&"
export * from "./Favicon.vue?vue&type=script&lang=js&"
import style0 from "./Favicon.vue?vue&type=style&index=0&id=bcfadf10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfadf10",
  null
  
)

export default component.exports